import { render, staticRenderFns } from "./StepThanks.vue?vue&type=template&id=7399cdc2&"
import script from "./StepThanks.vue?vue&type=script&lang=js&"
export * from "./StepThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports